// extracted by mini-css-extract-plugin
export default {"innerWrapper":"search-module--innerWrapper--a363e"};